import React, { FC } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import BackButton from './BackButton';

interface PageHeaderProps {
  mainTitle?: string;
  subTitle?: string;
  backButtonLabel?: string;
  backButtonLink?: string;
  button?: React.ReactNode;
}

const PageHeader: FC<PageHeaderProps> = (props) => {
  let { mainTitle, subTitle, backButtonLabel, backButtonLink, button } = props;

  if (backButtonLink) {
    return (
      <Grid container>
        <Grid item xs={12} lg={4} style={{ paddingLeft: 14, height: 50, marginBottom: 5 }}>
          <BackButton buttonLabel={backButtonLabel} buttonLink={backButtonLink} />
        </Grid>
        <Grid item xs={12} style={{ paddingLeft: 14, marginBottom: 3, marginTop: -8 }}>
          <Typography style={{ display: 'inline-block', fontSize: '20px' }} variant="h3">
            {mainTitle}
          </Typography>
          {subTitle && (
            <NavigateNextIcon
              fontSize="small"
              style={{
                color: '#3d5a80 !important',
                fontWeight: 700,
                fontSize: '20px !important',
                margin: '-4px 4px',
              }}
            />
          )}
          <Typography style={{ display: 'inline-block', fontSize: '20px' }} variant="h3">
            {subTitle}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container>
      <Grid item xs={12} style={{ marginTop: 20 }}>
        <Grid container justifyContent="space-between">
          <Grid item style={{ marginBottom: 3 }}>
            <Typography style={{ display: 'inline-block', fontSize: '20px' }} variant="h3">
              {mainTitle}
            </Typography>
            {subTitle && (
              <NavigateNextIcon
                fontSize="small"
                style={{
                  color: '#3d5a80 !important',
                  fontWeight: 700,
                  fontSize: '20px !important',
                  margin: '-4px 4px',
                }}
              />
            )}
            <Typography style={{ display: 'inline-block', fontSize: '20px' }} variant="h3">
              {subTitle}
            </Typography>
          </Grid>
          {button && <Grid item>{button}</Grid>}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PageHeader;
